import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { ChevronUpIcon } from "@heroicons/react/24/solid";
import { PropTypes } from "prop-types";

const SplcHierarchyOrgChartButton = ({ children, directSubordinates }) => {
  const style1 = {
    color: "#fff",
    borderRadius: "10px",
    padding: "0px 3px 0px 3px",
    fontSize: "8px",
    margin: "auto",
    backgroundColor: "white",
    border: "1.5px solid #A1A1A1",
    display: "flex",
    alignItems: "center",
    placeContent: "center",
    justifyContent: "center",
  };

  const number1 = {
    fontSize: "0.75rem",
    lineHeight: "1rem",
    paddingLeft: "0.25rem",
    color: "#A1A1A1",
    justifyContent: "center",
    alignItems: "center",
  };

  const arrow1 = {
    width: "0.5rem",
    height: "0.5rem",
    fontSize: "1rem",
    lineHeight: "1rem",
    color: "rgb(32 58 117)",
    paddingBottom: "1px",
  };

  const button1 = {
    display: "flex",
    width: "100%",
    height: "85%",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    right: "-3px",
    top: "13px",
  };

  return (
    <div className="node-button" style={button1}>
      <div className="flex items-center place-content-center" style={style1}>
        <span className="font-bold text-[#A1A1A1]" style={number1}>
          {directSubordinates}
        </span>
        {children ? (
          <ChevronUpIcon className="text-primary " style={arrow1} />
        ) : (
          <ChevronDownIcon className="text-primary " style={arrow1} />
        )}
      </div>
    </div>
  );
};

SplcHierarchyOrgChartButton.propTypes = {
  directSubordinates: PropTypes.number,
  children: PropTypes.array,
};

export default SplcHierarchyOrgChartButton;
